import { pipe } from 'fp-ts/lib/function';
import { failure, parse, success } from 'io-ts/Decoder';

import { Scopes as AcsScopes } from '../../../acs/Scopes';

/**
 * [LON-316] The scopes an admin may put on a user profile.
 *
 * `acs.Scope` accepts an optional `roles` array drawn from the full role list —
 * `god` included — which `getRolesForScope` merges into the user's effective
 * roles without any further check. That is what the "Change Scopes" tool relies
 * on, and it stays. On the admin user API, though, the only thing the caller is
 * authorised for is the `userGroup` (`bedc:user:{create,update}/user-group/…`),
 * so a role grant arriving here would let anyone who can edit a user escalate
 * that user to superuser. The admin UI never sends one; this rejects it.
 *
 * An empty `roles: []` is let through: profiles saved before this check still
 * carry one, and the admin UI posts a user's scopes back as it read them.
 */
export const Scopes = pipe(
	AcsScopes,
	parse((scopes) =>
		scopes.some((scope) => scope.roles?.length)
			? failure(
					scopes,
					'roles cannot be assigned through the admin user API; a scope grants the roles of its userGroup only'
				)
			: success(scopes)
	)
);
